import { RemediationRule } from '../../types/remediation-rule';
import { HeaderTitleRule } from './header-title/header-title-rule';
import { AriaEditorRule } from './aria-editor/aria-editor-rule';
import { ImageAltRule } from './image-alt';

export const RulesList: RemediationRule[] = [
  HeaderTitleRule,
  ImageAltRule,
  // FormLabelRule,
  AriaEditorRule,
];
